import { GetApiActionWithAuthorization } from "constantFunctions/apiActions";
import { PostApiWithAuthorizationAction } from "constantFunctions/apiActions";
import React, { useState } from "react";
import { Table } from "reactstrap";
import { Row, Col } from "reactstrap";
import { toast } from "react-toastify";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Input,
  Label,
} from "reactstrap";

function AddCreditModal(props) {
  const [credits, setCredits] = useState([{
    date: new Date().toISOString().split("T")[0],
    description: "",
    amount: 0,
    requiredAmount: false,
  }]);
  const renderHTML = () => {
    return credits.map((credit, index) => (
      <tr key={index}>
        <td>
            <Input
                bsSize="lg"
                className="mb-3"
                type="date"
                value={credit.date}
                onChange={(e) => {
                  const newCredits = [...credits];
                  newCredits[index].date = e.target.value;
                  setCredits(newCredits);
                }}
              />
        </td>
        <td>
            <Input
                className="mb-3"
                placeholder="Description"
                value={credit.description}
                style={{ width: "250px" }}
                onChange={(e) => {
                  const newCredits = [...credits];
                  newCredits[index].description = e.target.value;
                  setCredits(newCredits);
                }}
              />
        </td>
        <td>
            <Input
                className="mb-3"
                placeholder="Amount"
                type="number"
                value={credit.amount}
                style={{ width: "100px", borderColor: credit.requiredAmount ? "red" : "" }}
                onChange={(e) => {
                  const newCredits = [...credits];
                  newCredits[index].amount = parseInt(e.target.value);
                  setCredits(newCredits);
                  if (newCredits[index].amount === 0) {
                    newCredits[index].requiredAmount = true;
                  } else {
                    newCredits[index].requiredAmount = false;
                  }
                }}
              />
        </td>
        <td style={{ verticalAlign: "top" }}>
            {(index === credits.length - 1) && (
              <Button
                className="icon-cross"
                id="add-item"
                color="primary"
                onClick={(e) => {
                  addItemsHandler(index);
                }}
              >
                <i class="fas fa-plus-square"></i>
              </Button>
            )}
            {(credits.length > 1)&& (
              <Button
                id="remove"
                className="icon-cross"
                color="danger"
                title="remove"
                onClick={() => {
                  removeRowInItem(index);
                }}
              >
                <i className="fas fa-times"></i>
              </Button>)}
        </td>
      </tr>
    ));
  };

  const addItemsHandler = (index) => {
    let findCredit = credits.find((credit, i) => i === index);
    let amount = parseFloat(findCredit.amount);
    console.log(amount);
    if (isNaN(amount) || amount === 0) {
      findCredit.requiredAmount = true;
      credits[index] = findCredit;
      setCredits([...credits]);
    } else {
      setCredits([...credits, {
        date: new Date().toISOString().split("T")[0],
        description: "",
        amount: 0,
        requiredAmount: false,
      }]);
    }
  };

  const removeRowInItem = (index) => {
    const newCredits = [...credits];
    newCredits.splice(index, 1);
    setCredits(newCredits);
  };

  const submitHandler = () => {
    console.log("Submitting credits:", credits);
    //
    let allNotValid = credits.some(credit => isNaN(credit.amount) || credit.amount === 0);
    if (allNotValid) {
      toast.error("Some credits are not valid");
      return;
    }
    // You can add your API call or further processing logic here for the valid credits
    PostApiWithAuthorizationAction("common/create-new-credit", {
      credits
    }).then((res) => {
      props.loadCredits();
      // window.location.reload();
    });
  };

  return (
    <Modal
      isOpen={props.show}
      toggle={props.toggle}
      autoFocus={false}
      className="credit-modal">
      <ModalHeader toggle={props.toggle}>Add new Credit</ModalHeader>
      <ModalBody className="pb-0">
        <Row>
            <Col md="3" lg="6" xl="3">
                <Table className="desc-table" borderless>
                    <thead>
                    <tr>
                        <td>Date</td>
                        <td>Description</td>
                        <td>Amount</td>
                        <td></td>
                    </tr>
                    </thead>
                    <tbody>{renderHTML()}</tbody>
                </Table>
            </Col>
        </Row>
      </ModalBody>
      <ModalFooter className="pt-0 pb-2">
        <Button
        id="add-btn"
          color="primary"
          onClick={(e) => {
            submitHandler();
          }}
        >
          Add
        </Button>{" "}
        <Button color="secondary" onClick={props.toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default AddCreditModal;
